import React from "react"
import PropTypes from "prop-types"

export const ExperienceListingIcon = ({ height = 20, width = 20, color = "#A8A9AA", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="3" cy="5" r="1.5" fill={color} />
    <rect x="7" y="4" width="11" height="2" rx="1" fill={color} />
    <circle cx="3" cy="10" r="1.5" fill={color} />
    <rect x="7" y="9" width="11" height="2" rx="1" fill={color} />
    <circle cx="3" cy="15" r="1.5" fill={color} />
    <rect x="7" y="14" width="11" height="2" rx="1" fill={color} />
  </svg>
)

ExperienceListingIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string
}
